import { ICardItem, IMakeCardItem } from "."

let idSeq = 0

export const makeCardItem = ({
  owner,
  order,
  data
}: IMakeCardItem): ICardItem => ({
  id: ++idSeq,
  owner,
  status: "enter",
  order,
  data
})
